import React, { Component } from 'react';
import { Table, Input, Icon, Spin, Button, Tooltip, Modal } from 'antd';
import * as actions from '../../actions/index';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const confirm = Modal.confirm;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class MyList extends Component {

  constructor(props) {
    super(props)
    this.txt_search_onchange = this.txt_search_onchange.bind(this);
    this.showConfirm = this.showConfirm.bind(this);
    this.columns = [{
      title: 'List Name',
      dataIndex: 'PreferenceName',
      key: 'PreferenceName',
    }, {
      title: 'Last Modified',
      dataIndex: 'LastModified',
      key: 'LastModified',
    }, {
      title: 'Date Last Run',
      dataIndex: 'LastExecutionDate',
      key: 'LastExecutionDate',
    },
    {
      title: 'Date Last Count',
      dataIndex: 'LastRecordCount',
      key: 'LastRecordCount',
    },
    {
      title: 'Actions',
      dataIndex: 'Actions',
      key: 'Actions',
      render: (text, record) => (
        <div className='action-panel'>
          <div>
            <Tooltip placement="top" title="View this List">
              <Button type="primary" shape="circle" onClick={this.openAdvanceSearch.bind(this, record, 'v')} ><i className='fa fa-list-ul'></i></Button>
            </Tooltip>
          </div>
          <div>
            <Tooltip placement="top" title="Edit this List">
              <Button className='warning' shape="circle" onClick={this.openAdvanceSearch.bind(this, record, 'e')} ><i className='fa fa-pencil'></i></Button>
            </Tooltip>
          </div>
          <div>
            <Tooltip placement="top" title="Delete this List">
              <Button onClick={()=>this.showConfirm(record.PreferenceName)} className='danger' shape="circle"><i className='fa fa-trash'></i></Button>
            </Tooltip>
          </div>
        </div>
      )
    }]
  }

  openAdvanceSearch(record, mode){

    window.location = '/list-and-search/'+record.PreferenceName+'/'+record.ListType+'/'+mode
 
    // this.props.callbackchange("1", "clear");

  }

  showConfirm = (PreferenceName) => {
    let self = this
    confirm({
      title: 'Confirm',
      content: 'Are you sure want to delete this list?',
      onOk() {
        self.props.actions.deletepubliclist(PreferenceName)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  txt_search_onchange(e) {
    let searchtxt = e.target.value
    this.props.actions.searchpubliclist(searchtxt)
  }

  componentDidMount = () => {
    this.props.actions.getpublicpreferencelist()
  }

  rendermylist = () => {
    if (this.props.preferencelist) {
      let PreferenceNameslist = this.props.preferencelist
      return <Table
        ref={el => (this.componentRef = el)}
        dataSource={PreferenceNameslist.PreferenceNames}
        columns={this.columns}
        pagination={false} />
    } else {
      return <div>
        <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Public Lists..." />
      </div>
    }
  }

  render() {
    return (
      <div>
         <div className="contentSearch">
          <Input name="txt_search" onChange={this.txt_search_onchange} className="searchInput" size="large" prefix={< Icon type="search" />} placeholder="Search by List Name" />
        </div>
        {this.rendermylist()}
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    preferencelistloading: state.publicpreferencelistreducer.loading,
    preferencelist: state.publicpreferencelistreducer.preferencelist
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(MyList);





// WEBPACK FOOTER //
// ./src/components/ListandAdvancedSearch/PublicList.js